<template>
    <div class="calc-disclaimer">
        <span class="calc-disclaimer__icon">
            <CalcIcon name="warning" />
        </span>
        <span>
            <b>{{ $t(label) }}</b> {{ $t(body) }}
        </span>
    </div>
</template>

<script>
import CalcIcon from './CalcIcon.vue'

export default {
    name: 'CalcDisclaimer',

    components: { CalcIcon },

    props: {
        label: {
            type: String,
            default: '§calc.step2.disclaimer.label',
        },
        body: {
            type: String,
            default: '§calc.step2.disclaimer.body',
        },
    },
}
</script>

<style scoped>
.calc-disclaimer {
    width: 100%;
    max-width: var(--calc-card-w);
    background: var(--calc-green-mint);
    border: 0.2px solid white;
    border-radius: 16px;
    padding: 18px 22px;
    display: flex;
    gap: 14px;
    align-items: flex-start;
    font-size: 14px;
    line-height: 1.5;
    color: var(--calc-ink);
}

.calc-disclaimer__icon {
    width: 24px;
    height: 24px;
    border-radius: 100px;
    background: var(--calc-green-deep);
    color: white;
    display: grid;
    place-items: center;
    flex: 0 0 auto;
    margin-top: 1px;
}

.calc-disclaimer__icon :deep(svg) {
    width: 12px;
    height: 12px;
}

.calc-disclaimer b {
    font-weight: 600;
}
</style>
